// index.ts
// DO NOT MESS WITH THE IMPORTS ORDER!
// IT IS IMPORTANT FOR THE PRISMJS TO WORK PROPERLY!
// The order of the imports is important because certain languages are dependent on others.
// For example, if a language is dependent on another language, the dependent language must be imported after the language it depends on.
// This file is used to import all the languages and plugins needed for PrismJS to work properly in the application.
// import 'prismjs';
import Prism from 'prismjs';
// plugins
import 'prismjs/plugins/autoloader/prism-autoloader';

// languages
import 'prismjs/components/prism-markup.min';
import 'prismjs/components/prism-markup-templating.min';
import 'prismjs/components/prism-css.min';
import 'prismjs/components/prism-clike.min';
import 'prismjs/components/prism-javascript.min';
import 'prismjs/components/prism-abap.min';
import 'prismjs/components/prism-abnf.min';
import 'prismjs/components/prism-actionscript.min';
import 'prismjs/components/prism-ada.min';
import 'prismjs/components/prism-agda.min';
import 'prismjs/components/prism-al.min';
import 'prismjs/components/prism-antlr4.min';
import 'prismjs/components/prism-apacheconf.min';
import 'prismjs/components/prism-apex.min';
import 'prismjs/components/prism-apl.min';
import 'prismjs/components/prism-applescript.min';
import 'prismjs/components/prism-aql.min';
import 'prismjs/components/prism-arff.min';
import 'prismjs/components/prism-armasm.min';
import 'prismjs/components/prism-arturo.min';
import 'prismjs/components/prism-asciidoc.min';
import 'prismjs/components/prism-aspnet.min';
import 'prismjs/components/prism-asm6502.min';
import 'prismjs/components/prism-asmatmel.min';
import 'prismjs/components/prism-autohotkey.min';
import 'prismjs/components/prism-autoit.min';
import 'prismjs/components/prism-avisynth.min';
import 'prismjs/components/prism-avro-idl.min';
import 'prismjs/components/prism-awk.min';
import 'prismjs/components/prism-bash.min';
import 'prismjs/components/prism-basic.min';
import 'prismjs/components/prism-batch.min';
import 'prismjs/components/prism-bbcode.min';
import 'prismjs/components/prism-bbj.min';
import 'prismjs/components/prism-bicep.min';
import 'prismjs/components/prism-birb.min';
import 'prismjs/components/prism-bnf.min';
import 'prismjs/components/prism-bqn.min';
import 'prismjs/components/prism-brainfuck.min';
import 'prismjs/components/prism-brightscript.min';
import 'prismjs/components/prism-bro.min';
import 'prismjs/components/prism-bsl.min';
import 'prismjs/components/prism-c.min';
import 'prismjs/components/prism-csharp.min';
import 'prismjs/components/prism-cpp.min';
import 'prismjs/components/prism-cfscript.min';
import 'prismjs/components/prism-chaiscript.min';
import 'prismjs/components/prism-cil.min';
import 'prismjs/components/prism-cilkc.min';
import 'prismjs/components/prism-cilkcpp.min';
import 'prismjs/components/prism-clojure.min';
import 'prismjs/components/prism-cmake.min';
import 'prismjs/components/prism-cobol.min';
import 'prismjs/components/prism-coffeescript.min';
import 'prismjs/components/prism-concurnas.min';
import 'prismjs/components/prism-csp.min';
import 'prismjs/components/prism-cooklang.min';
import 'prismjs/components/prism-coq.min';
import 'prismjs/components/prism-css-extras.min';
import 'prismjs/components/prism-csv.min';
import 'prismjs/components/prism-cue.min';
import 'prismjs/components/prism-cypher.min';
import 'prismjs/components/prism-d.min';
import 'prismjs/components/prism-dart.min';
import 'prismjs/components/prism-dataweave.min';
import 'prismjs/components/prism-dax.min';
import 'prismjs/components/prism-dhall.min';
import 'prismjs/components/prism-diff.min';
import 'prismjs/components/prism-django.min';
import 'prismjs/components/prism-dns-zone-file.min';
import 'prismjs/components/prism-docker.min';
import 'prismjs/components/prism-dot.min';
import 'prismjs/components/prism-ebnf.min';
import 'prismjs/components/prism-editorconfig.min';
import 'prismjs/components/prism-eiffel.min';
import 'prismjs/components/prism-ejs.min';
import 'prismjs/components/prism-elixir.min';
import 'prismjs/components/prism-elm.min';
import 'prismjs/components/prism-etlua.min';
import 'prismjs/components/prism-erb.min';
import 'prismjs/components/prism-erlang.min';
import 'prismjs/components/prism-excel-formula.min';
import 'prismjs/components/prism-fsharp.min';
import 'prismjs/components/prism-factor.min';
import 'prismjs/components/prism-false.min';
import 'prismjs/components/prism-firestore-security-rules.min';
import 'prismjs/components/prism-flow.min';
import 'prismjs/components/prism-fortran.min';
import 'prismjs/components/prism-ftl.min';
import 'prismjs/components/prism-gml.min';
import 'prismjs/components/prism-gap.min';
import 'prismjs/components/prism-gcode.min';
import 'prismjs/components/prism-gdscript.min';
import 'prismjs/components/prism-gedcom.min';
import 'prismjs/components/prism-gettext.min';
import 'prismjs/components/prism-gherkin.min';
import 'prismjs/components/prism-git.min';
import 'prismjs/components/prism-glsl.min';
import 'prismjs/components/prism-gn.min';
import 'prismjs/components/prism-linker-script.min';
import 'prismjs/components/prism-go.min';
import 'prismjs/components/prism-go-module.min';
import 'prismjs/components/prism-gradle.min';
import 'prismjs/components/prism-graphql.min';
import 'prismjs/components/prism-groovy.min';
import 'prismjs/components/prism-haml.min';
import 'prismjs/components/prism-handlebars.min';
import 'prismjs/components/prism-haskell.min';
import 'prismjs/components/prism-haxe.min';
import 'prismjs/components/prism-hcl.min';
import 'prismjs/components/prism-hlsl.min';
import 'prismjs/components/prism-hoon.min';
import 'prismjs/components/prism-http.min';
import 'prismjs/components/prism-hpkp.min';
import 'prismjs/components/prism-hsts.min';
import 'prismjs/components/prism-ichigojam.min';
import 'prismjs/components/prism-icon.min';
import 'prismjs/components/prism-icu-message-format.min';
import 'prismjs/components/prism-idris.min';
import 'prismjs/components/prism-ignore.min';
import 'prismjs/components/prism-inform7.min';
import 'prismjs/components/prism-ini.min';
import 'prismjs/components/prism-io.min';
import 'prismjs/components/prism-j.min';
import 'prismjs/components/prism-java.min';
import 'prismjs/components/prism-javastacktrace.min';
import 'prismjs/components/prism-jexl.min';
import 'prismjs/components/prism-jolie.min';
import 'prismjs/components/prism-jq.min';
import 'prismjs/components/prism-json.min';
import 'prismjs/components/prism-json5.min';
import 'prismjs/components/prism-jsonp.min';
import 'prismjs/components/prism-jsstacktrace.min';
import 'prismjs/components/prism-js-templates.min';
import 'prismjs/components/prism-julia.min';
import 'prismjs/components/prism-keepalived.min';
import 'prismjs/components/prism-keyman.min';
import 'prismjs/components/prism-kotlin.min';
import 'prismjs/components/prism-kumir.min';
import 'prismjs/components/prism-kusto.min';
import 'prismjs/components/prism-latex.min';
import 'prismjs/components/prism-latte.min';
import 'prismjs/components/prism-less.min';
import 'prismjs/components/prism-lilypond.min';
import 'prismjs/components/prism-liquid.min';
import 'prismjs/components/prism-lisp.min';
import 'prismjs/components/prism-livescript.min';
import 'prismjs/components/prism-llvm.min';
import 'prismjs/components/prism-log.min';
import 'prismjs/components/prism-lolcode.min';
import 'prismjs/components/prism-lua.min';
import 'prismjs/components/prism-magma.min';
import 'prismjs/components/prism-makefile.min';
import 'prismjs/components/prism-mata.min';
import 'prismjs/components/prism-matlab.min';
import 'prismjs/components/prism-maxscript.min';
import 'prismjs/components/prism-mel.min';
import 'prismjs/components/prism-mermaid.min';
import 'prismjs/components/prism-metafont.min';
import 'prismjs/components/prism-mizar.min';
import 'prismjs/components/prism-mongodb.min';
import 'prismjs/components/prism-monkey.min';
import 'prismjs/components/prism-moonscript.min';
import 'prismjs/components/prism-n1ql.min';
import 'prismjs/components/prism-n4js.min';
import 'prismjs/components/prism-nand2tetris-hdl.min';
import 'prismjs/components/prism-naniscript.min';
import 'prismjs/components/prism-nasm.min';
import 'prismjs/components/prism-neon.min';
import 'prismjs/components/prism-nevod.min';
import 'prismjs/components/prism-nginx.min';
import 'prismjs/components/prism-nim.min';
import 'prismjs/components/prism-nix.min';
import 'prismjs/components/prism-nsis.min';
import 'prismjs/components/prism-objectivec.min';
import 'prismjs/components/prism-ocaml.min';
import 'prismjs/components/prism-odin.min';
import 'prismjs/components/prism-opencl.min';
import 'prismjs/components/prism-openqasm.min';
import 'prismjs/components/prism-oz.min';
import 'prismjs/components/prism-parigp.min';
import 'prismjs/components/prism-parser.min';
import 'prismjs/components/prism-pascal.min';
import 'prismjs/components/prism-pascaligo.min';
import 'prismjs/components/prism-psl.min';
import 'prismjs/components/prism-pcaxis.min';
import 'prismjs/components/prism-peoplecode.min';
import 'prismjs/components/prism-perl.min';
import 'prismjs/components/prism-php.min';
import 'prismjs/components/prism-plant-uml.min';
import 'prismjs/components/prism-powerquery.min';
import 'prismjs/components/prism-powershell.min';
import 'prismjs/components/prism-processing.min';
import 'prismjs/components/prism-prolog.min';
import 'prismjs/components/prism-promql.min';
import 'prismjs/components/prism-properties.min';
import 'prismjs/components/prism-protobuf.min';
import 'prismjs/components/prism-pug.min';
import 'prismjs/components/prism-puppet.min';
import 'prismjs/components/prism-pure.min';
import 'prismjs/components/prism-purebasic.min';
import 'prismjs/components/prism-purescript.min';
import 'prismjs/components/prism-python.min';
import 'prismjs/components/prism-qsharp.min';
import 'prismjs/components/prism-q.min';
import 'prismjs/components/prism-qml.min';
import 'prismjs/components/prism-qore.min';
import 'prismjs/components/prism-r.min';
import 'prismjs/components/prism-reason.min';
import 'prismjs/components/prism-regex.min';
import 'prismjs/components/prism-rego.min';
import 'prismjs/components/prism-renpy.min';
import 'prismjs/components/prism-rescript.min';
import 'prismjs/components/prism-rest.min';
import 'prismjs/components/prism-rip.min';
import 'prismjs/components/prism-roboconf.min';
import 'prismjs/components/prism-robotframework.min';
import 'prismjs/components/prism-ruby.min';
import 'prismjs/components/prism-rust.min';
import 'prismjs/components/prism-sas.min';
import 'prismjs/components/prism-sass.min';
import 'prismjs/components/prism-scss.min';
import 'prismjs/components/prism-scala.min';
import 'prismjs/components/prism-scheme.min';
import 'prismjs/components/prism-shell-session.min';
import 'prismjs/components/prism-smali.min';
import 'prismjs/components/prism-smalltalk.min';
import 'prismjs/components/prism-smarty.min';
import 'prismjs/components/prism-sml.min';
import 'prismjs/components/prism-solidity.min';
import 'prismjs/components/prism-solution-file.min';
import 'prismjs/components/prism-soy.min';
import 'prismjs/components/prism-splunk-spl.min';
import 'prismjs/components/prism-sqf.min';
import 'prismjs/components/prism-sql.min';
import 'prismjs/components/prism-squirrel.min';
import 'prismjs/components/prism-stan.min';
import 'prismjs/components/prism-stata.min';
import 'prismjs/components/prism-iecst.min';
import 'prismjs/components/prism-stylus.min';
import 'prismjs/components/prism-supercollider.min';
import 'prismjs/components/prism-swift.min';
import 'prismjs/components/prism-systemd.min';
import 'prismjs/components/prism-t4-templating.min';
import 'prismjs/components/prism-t4-cs.min';
import 'prismjs/components/prism-t4-vb.min';
import 'prismjs/components/prism-tap.min';
import 'prismjs/components/prism-tcl.min';
import 'prismjs/components/prism-tt2.min';
import 'prismjs/components/prism-textile.min';
import 'prismjs/components/prism-toml.min';
import 'prismjs/components/prism-tremor.min';
import 'prismjs/components/prism-turtle.min';
import 'prismjs/components/prism-twig.min';
import 'prismjs/components/prism-typescript.min';
import 'prismjs/components/prism-typoscript.min';
import 'prismjs/components/prism-unrealscript.min';
import 'prismjs/components/prism-uorazor.min';
import 'prismjs/components/prism-uri.min';
import 'prismjs/components/prism-v.min';
import 'prismjs/components/prism-vala.min';
import 'prismjs/components/prism-vbnet.min';
import 'prismjs/components/prism-velocity.min';
import 'prismjs/components/prism-verilog.min';
import 'prismjs/components/prism-vhdl.min';
import 'prismjs/components/prism-vim.min';
import 'prismjs/components/prism-visual-basic.min';
import 'prismjs/components/prism-warpscript.min';
import 'prismjs/components/prism-wasm.min';
import 'prismjs/components/prism-web-idl.min';
import 'prismjs/components/prism-wgsl.min';
import 'prismjs/components/prism-wiki.min';
import 'prismjs/components/prism-wolfram.min';
import 'prismjs/components/prism-wren.min';
import 'prismjs/components/prism-xeora.min';
import 'prismjs/components/prism-xml-doc.min';
import 'prismjs/components/prism-xojo.min';
import 'prismjs/components/prism-xquery.min';
import 'prismjs/components/prism-yaml.min';
import 'prismjs/components/prism-yang.min';
import 'prismjs/components/prism-zig.min';
import 'prismjs/components/prism-jsx.min';
import 'prismjs/components/prism-tsx.min';
import 'prismjs/components/prism-cshtml.min';
import 'prismjs/components/prism-markdown.min';
import 'prismjs/components/prism-arduino.min';
import 'prismjs/components/prism-bison.min';
import 'prismjs/components/prism-crystal.min';
import 'prismjs/components/prism-javadoclike.min';
import 'prismjs/components/prism-javadoc.min';
import 'prismjs/components/prism-jsdoc.min';
import 'prismjs/components/prism-js-extras.min';
import 'prismjs/components/prism-phpdoc.min';
import 'prismjs/components/prism-php-extras.min';
import 'prismjs/components/prism-plsql.min';
import 'prismjs/components/prism-racket.min';
import 'prismjs/components/prism-sparql.min';

export default Prism;